import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';
import {trapFocus, removeTrapFocus} from '@shopify/theme-a11y';

/**
 * @param {HTMLElement} element
 * @param {*} opts
 */
export function Alert(element, opts = {}) {
  const defaults = {
    activeClass: 'is-active',
    toggle: '[data-alert-toggle]',
    container: '[data-alert-container]',
    content: '[data-alert-content]',
    clickOverlayToClose: true,
  };

  if (!element) {
    return {};
  }

  const options = {
    ...defaults,
    ...opts,
    ...element.dataset,
  };

  const container = element.querySelector(options.container);

  bindEventListeners();

  function bindEventListeners() {
    element.addEventListener('click', handleToggleClick);
    document.documentElement.addEventListener('alert:close', close);

    if (options.clickOverlayToClose) {
      document.documentElement.addEventListener('click', handleOverlayClick);
    }
  }

  function removeEventListeners() {
    element.removeEventListener('click', handleToggleClick);
    document.documentElement.removeEventListener('alert:close', close);

    if (options.clickOverlayToClose) {
      document.documentElement.removeEventListener('click', handleOverlayClick);
    }
  }

  /**
   * @param {Event} event
   */
  function handleOverlayClick(event) {
    const target = event.target;
    const contentMatch = target.closest(options.content);
    const toggleMatch = target.closest(options.toggle);

    if (contentMatch || toggleMatch) {
      return;
    }

    close();
  }

  /**
   * @param {Event} event
   */
  function handleToggleClick(event) {
    const state = isActive();
    const target = event.target;
    const match = target.closest(options.toggle);

    if (!match) {
      return;
    }

    if (state) {
      close();
      return;
    }

    open();
  }

  function isActive() {
    return container.classList.contains(options.activeClass);
  }

  function open() {
    container.classList.add(options.activeClass);
    disableBodyScroll(container);
    trapFocus(container);
  }

  function close() {
    container.classList.remove(options.activeClass);
    enableBodyScroll(container);
    removeTrapFocus(container);
  }

  function destroy() {
    removeEventListeners();
  }

  return {
    destroy,
  };
}
